/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo } from "react";

import { UncontrolledTooltip, Spinner } from "reactstrap";

import Viewer from "react-viewer";

// Toast
import toastr from "toastr";
import "toastr/build/toastr.min.css";

// Custom components
import FavoriteMessage from "../../../ActiveChat/subcomponents/FavoriteMessage/FavoriteMessage";

//i18n
import { withTranslation } from "react-i18next";

// Luxon
import DateTime from "luxon/src/datetime.js";

// Custom methods
import { isFunction } from "../../../../../../Libs/CustomMethods/customMethods";

//Redux
import { useSelector, useDispatch } from "react-redux";

// actions
import {
  starMsg,
  resetStarObj,
} from "../../../../../../store/favoriteMessages/actions";

// Assets
import noImage from "../../../../../../assets/images/image-not-found.png";
import locationThumb from "../../../../../../assets/images/location-thumb.png";
import fileIcon from "../../../../../../assets/images/files.png";

// Theme style
import "./lightTheme.scss";

import { GenerateSummary } from "../../../../../Common/Summary/GenerateSummary";
import ResultSummary from "../../../../../Common/Summary/ResultSummary";
import { AutomaticallySummarize } from "../../../../../Common/Summary/AutomaticallySummarize";
import { useLocation } from "react-router-dom";

import agentIcon from "../../../../../../assets/images/agents.svg";

const importDarkMode = (mainTheme) => {
  if (mainTheme === "dark") {
    require("./darkTheme.scss");
  }
};

const MessageItem = ({
  t,
  isRight,
  name,
  message,
  time,
  msg,
  file,
  pics,
  enableStarMsg,
  isFavorite = true,
  onChange,
  hasObserver,
  isSkillSummaryActived
}) => {
  const { state } = useLocation();
  const spyConversationId = state?.spyConversationId || null;
  const hasObserverWatching = useMemo(() => spyConversationId || hasObserver, [spyConversationId, hasObserver]);

  const { mainTheme } = useSelector((state) => state.Layout);
  const { status: starStatus, data: starData } = useSelector(
    (state) => state.FavoriteMessages
  );

  importDarkMode(mainTheme);

  const dispatch = useDispatch();

  const [visible, setVisible] = useState(false);
  const [activeItem, setActiveItem] = useState(0);

  const showToast = (type, message, delay) => {
    setTimeout(() => toastr[type](message), delay);
  };
  toastr.options = {
    closeButton: false,
    debug: false,
    newestOnTop: false,
    progressBar: true,
    positionClass: "toast-top-right",
    preventDuplicates: true,
    onclick: null,
    showDuration: "200",
    hideDuration: "200",
    timeOut: "4000",
    extendedTimeOut: "2000",
    showEasing: "swing",
    hideEasing: "linear",
    showMethod: "fadeIn",
    hideMethod: "fadeOut",
  };

  const messageIcon = {
    sending: "bx bx-time-five",
    sent: "bx bx-check",
    delivered: "bx bx-check-double",
    read: "bx bx-check-double text-success",
    error: "bx bx-error text-warning",
  };

  const agentInfo = {
    icon: agentIcon,
    alt: "ai agent icon",
    description: "Artificial Intelligence Conversational Agent",
    visible: true,
  };

  const loadingContent = (type) => {
    let url =
      file?.file_url?.search("data:image/") !== -1
        ? file?.file_url
        : "data:" + file?.mime_type + ";base64, " + file?.file_url;
    return (
      <>
        <div className="blurBox">
          <div className="background">
            <Spinner animation="border" size="sm" className="spinner" />
          </div>
          {(type === "image" || type === "video") && (
            <img
              alt="icon"
              className="ml-auto mr-1 my-auto"
              width="100%"
              height="100%"
              src={url}
            />
          )}
          {type === "audio" && (
            <audio controls>
              <source src={file?.file_url} type={file.mime_type} />
            </audio>
          )}
        </div>
      </>
    );
  };

  const errorContent = (type) => {
    let url =
      file?.file_url?.search("data:image/") !== -1
        ? file?.file_url
        : "data:" + file?.mime_type + ";base64, " + file?.file_url;
    return (
      <>
        <div className="blurBox">
          <div className="background">
            <i className="bx bx-error-circle"></i>
          </div>
          {(type === "image" || type === "video") && (
            <img
              alt="icon"
              className="ml-auto mr-1 my-auto"
              width="100%"
              height="100%"
              src={url}
            />
          )}
          {type === "audio" && (
            <audio controls>
              <source src={file?.file_url} type={file.mime_type} />
            </audio>
          )}
        </div>
      </>
    );
  };

  if(msg.by === "iag:agents") {
    isRight = true;
  }

  const handleFavoriteMsg = () => {
    if (enableStarMsg && !starStatus?.star_message?.loading && msg?.currentId) {
      dispatch(starMsg(msg?.chatId, msg?.currentId, !msg?.favorite));
    }
  };

  const handleCustomClass = useMemo(() => {
    if (starStatus?.star_message?.loading) {
      if (starData?.msgId === msg?.currentId) {
        return "pulsing";
      } else {
        return "blocked";
      }
    }
  }, [starStatus?.star_message?.loading]);

  useEffect(() => {
    if (starData?.msgId === msg?.currentId) {
      let star_message = starStatus?.star_message;

      if (star_message?.success?.status) {
        isFunction(onChange) &&
          onChange({
            action: "star_message",
            data: {
              conversationId: msg?.chatId,
              currentId: msg?.currentId,
              starred: star_message?.success?.starred,
            },
          });
        dispatch(resetStarObj());
      } else if (star_message?.error?.status) {
        showToast("error", t("Cannot star the message. Please try again."));
        dispatch(resetStarObj());
      }
    }
  }, [starStatus?.star_message]);

  if (msg.by === "ai") {
    const dataUser = JSON.parse(localStorage.getItem("authUser"));

    if (!msg.summary) {
      if (hasObserverWatching || !isSkillSummaryActived) return null
      return (
        <div style={{ marginBottom: 24 }}>
          <GenerateSummary
            messageId={msg.currentId}
            conversationId={msg?.chatId}
            isDisabled={msg.summaryDisabled}
          />
        </div>
      );
    }

    return (
      <div className="d-flex flex-column" style={{ marginBottom: 24 }}>
        <div className="summary-chat-container">
          <ResultSummary
            keywords={msg.summaryKeywords ?? []}
            summary={msg.summary}
          />
          {dataUser?.id === msg.userId}
          {(!hasObserverWatching || !isSkillSummaryActived) && <AutomaticallySummarize />}
        </div>
        <div
          className="chat-time order-3 ml-2 align-self-end"
          style={{ marginTop: 0 }}
        >
          {`${name} | `}
          {time ? DateTime.fromJSDate(new Date(time)).toFormat("HH':'mm") : "-"}
        </div>
      </div>
    );
  }

  return (
    <>
      <div
        className={`messageItem ${isRight ? "right" : ""} ${
          enableStarMsg ? "favoriteEnabled" : ""
        }`}
        style={{ clear: "both" }}
      >
        {pics && file?.file_url && (
          <Viewer
            visible={visible}
            onClose={() => {
              setVisible(false);
            }}
            images={pics}
            activeIndex={activeItem}
            className="customViewer"
          />
        )}
        <div className="conversation-list">
          <div className="d-flex">
            <div
              className={`ctext-wrap flex-grow-1 
                ${msg.by === "iag:agents" ? "agents-chat-container" : ""} 
                ${isRight ? "order-2" : "order-1"} p-2`}
            >
              <div
                className={`imgContainer ${!file ? "d-none" : "d-flex"} ${
                  file?.thumb_url ? "flex-column" : ""
                } pointer`}
                onClick={() => {
                  if (file?.mime_type?.split("/")[0] === "application") {
                    let win = window.open(file?.file_url, "_blank");
                    win.focus();
                  }
                }}
                style={{ maxWidth: "245px" }}
              >
                {msg?.status?.sending &&
                (file?.mime_type?.split("/")[0] === "image" ||
                  file?.mime_type?.split("/")[0] === "video" ||
                  file?.mime_type?.split("/")[0] === "audio") ? (
                  loadingContent(file?.mime_type?.split("/")[0])
                ) : msg?.status?.error &&
                  (file?.mime_type?.split("/")[0] === "image" ||
                    file?.mime_type?.split("/")[0] === "video" ||
                    file?.mime_type?.split("/")[0] === "audio") ? (
                  errorContent(file?.mime_type?.split("/")[0])
                ) : file?.mime_type ? (
                  file.mime_type.split("/")[0] === "image" ||
                  file.mime_type.split("/")[0] === "application" ? (
                    <img
                      alt=""
                      className="mr-1 my-auto"
                      width={
                        file.mime_type.split("/")[0] === "application"
                          ? "30"
                          : "100%"
                      }
                      height={
                        file.mime_type.split("/")[0] === "application"
                          ? "30"
                          : "100%"
                      }
                      src={
                        (file.mime_type.split("/")[0] === "application" &&
                          file?.thumb_url) ||
                        (file.mime_type.split("/")[0] === "image" &&
                          file?.file_url) ||
                        fileIcon
                      }
                      onClick={(e) => {
                        if (pics && file.mime_type.split("/")[0] === "image") {
                          let i = pics?.find(
                            (pic) => pic.src === e?.target?.src
                          );
                          let pos =
                            pics?.indexOf(i) !== -1 ? pics?.indexOf(i) : 0;
                          setActiveItem(pos);
                          setVisible(true);
                        }
                      }}
                      onError={(e) => {
                        e.target.src = noImage;
                      }}
                    />
                  ) : file.mime_type.split("/")[0] === "audio" ? (
                    <audio controls>
                      <source src={file?.file_url} type={file.mime_type} />
                    </audio>
                  ) : (
                    file?.mime_type.split("/")[0] === "video" && (
                      <video
                        width="200"
                        height="300"
                        controls
                        onError={(e) => {
                          e.target.src = noImage;
                        }}
                      >
                        <source src={file?.file_url} type={file.mime_type} />
                      </video>
                    )
                  )
                ) : (
                  ""
                )}

                {file?.mime_type?.split("/")[0] === "application" && (
                  <p
                    style={{ overflowWrap: "anywhere" }}
                    className="text-left my-auto"
                  >
                    {file?.file_name}
                  </p>
                )}
              </div>
              {msg?.location && (
                <div style={{ maxWidth: "245px" }}>
                  <a
                    href={msg.location.location_url}
                    target="_blank"
                    rel="noreferrer"
                  >
                    <img
                      alt="Location"
                      className="rounded border mb-2"
                      width="100%"
                      height="100%"
                      src={locationThumb}
                    />
                  </a>
                </div>
              )}
              <p
                style={{ overflowWrap: "anywhere", whiteSpace: "pre-wrap" }}
                className="text-left m-0 escapeDragScroll"
              >
                {message}
              </p>
            </div>
            {isFavorite && (
              <FavoriteMessage
                msgId={msg?.currentId}
                enableClick={enableStarMsg && msg?.currentId}
                checked={msg?.favorite}
                order={isRight ? "order-1" : "order-2"}
                onClick={handleFavoriteMsg}
                customClass={handleCustomClass}
              />
            )}
          </div>

          <div
            className={`chat-time d-flex mb-0 ${
              isRight ? "justify-content-end" : "justify-content-start"
            }`}
          >
            {msg?.private && (
              <>
                <div className="order-2" id={`private-${msg?.id}`}>
                  <span className="privateMsg">{t("Private")}</span>
                </div>
                <UncontrolledTooltip
                  placement="bottom"
                  target={`private-${msg?.id}`}
                  className="uncontrolledTooltip"
                >
                  {t("This message is only visible to managers and agents")}
                </UncontrolledTooltip>
              </>
            )}
            <div className={isRight ? "order-3 ml-2" : "order-1 mr-2"}>
              <i
                className={`${
                  msg?.userId
                    ? msg?.status
                      ? msg?.status?.read
                        ? messageIcon.read
                        : msg?.status?.delivered
                        ? messageIcon.delivered
                        : msg?.status?.sent
                        ? messageIcon.delivered
                        : msg?.status?.sending
                        ? messageIcon.sending
                        : messageIcon.error
                      : messageIcon.delivered
                    : null
                } align-middle mr-1`}
              ></i>
              {msg.by === "iag:agents" ? "IA Agent" 
              : name} 
              
              {msg.by === "iag:agents" 
              ? <img 
                  src={agentInfo.icon}
                  alt={agentInfo.alt}
                  width={12}
                  height={13}    
                  className="ml-1 mr-1"          
                /> 
              : " "}
              
              
              | {" "}
              {time
                ? DateTime.fromJSDate(new Date(time)).toFormat("HH':'mm")
                : "-"}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default withTranslation()(React.memo(MessageItem));
